import { useParams } from 'react-router';

import { useAppSelector } from '../../../../../store/hooks';
import { getActiveMandantIdSelector } from '../../../../shared/store/selectors/get-active-mandant-id/get-active-mandant-id.selector';
import { getIsAppLoadingSelector } from '../../../../shared/store/selectors/get-is-app-loading/get-is-app-loading.selector';
import { StatisticsTableConfigModel } from '../components/statistics-table/models/statistics-table-config.model';
import { getStatisticsPaginationFiltersSelector } from '../store/selectors/get-statistics-pagination-filters.selector';
import { getStatisticsSelector } from '../store/selectors/get-statistics.selector';

export const useGetStatisticsTableSelectors =
  (): StatisticsTableConfigModel => {
    const statistics = useAppSelector(getStatisticsSelector);
    const isLoading = useAppSelector(getIsAppLoadingSelector);
    const paginationParams = useAppSelector(
      getStatisticsPaginationFiltersSelector
    );
    const { id: appId } = useParams();
    const activeMandantId = useAppSelector(getActiveMandantIdSelector);
    return { statistics, isLoading, paginationParams, appId, activeMandantId };
  };
